import React from "react";
import PropTypes from "prop-types";
import "./Pagination.css"; // Ajoutez un fichier CSS pour la pagination si nécessaire.

const Pagination = ({
  currentPage,
  totalPages,
  dataPerPage,
  setDataPerPage,
  handlePageChange,
}) => {
  return (
    <div className="pagination-container">
      {/* Première page */}
      <button
        className={`pagination-arrow ${currentPage === 1 ? "disabled" : ""}`}
        onClick={() => handlePageChange(1)}
        disabled={currentPage === 1}
      >
        &laquo;
      </button>

      {/* Page précédente */}
      <button
        className={`pagination-arrow ${currentPage === 1 ? "disabled" : ""}`}
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        &lt;
      </button>

      {/* Boutons pour les pages */}
      {Array.from({ length: totalPages }, (_, index) => (
        <button
          key={index + 1}
          className={`pagination-button ${
            currentPage === index + 1 ? "active" : ""
          }`}
          onClick={() => handlePageChange(index + 1)}
        >
          {index + 1}
        </button>
      ))}

      {/* Page suivante */}
      <button
        className={`pagination-arrow ${
          currentPage === totalPages ? "disabled" : ""
        }`}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        &gt;
      </button>

      {/* Dernière page */}
      <button
        className={`pagination-arrow ${
          currentPage === totalPages ? "disabled" : ""
        }`}
        onClick={() => handlePageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        &raquo;
      </button>

      {/* Sélecteur pour le nombre d'éléments par page */}
      <select
        className="pagination-select"
        value={dataPerPage}
        onChange={(e) => setDataPerPage(Number(e.target.value))}
      >
        {[5, 10, 20, 50, 100].map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Pagination;
